import { Route, Routes } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import FloatingActions from "./components/FloatingActions";
import Footer from "./components/layout/Footer";
import Navbar from "./components/layout/Navbar";
import NotFound from "./components/layout/NotFound";
import ScrollToTop from "./components/ScrollToTop";
import About from "./pages/About/About";
import Agents from "./pages/Agents/Agents";
import Contact from "./pages/Contact/Contact";
import Home from "./pages/Home/Home";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import RoiCalculatorPage from "./pages/Tools/RoiCalculatorPage";

// Later we will add other pages here

export default function App() {
  return (
    <>
      {/* SCROLL RESET ON ROUTE CHANGE */}
      <ScrollToTop />
      {/* NAVBAR ALWAYS ON TOP */}
      <Navbar />

      {/* PAGE CONTENT */}
      <Routes>
        {/* <Route path="/" element={<Maintenance />} /> */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/agents" element={<Agents />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/tools/roi-calculator" element={<RoiCalculatorPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <FloatingActions />
      <Footer />
    </>
  );
}
